import { ContentType } from './helpers/ContentType'
import { IObjectResponse } from '../models/IResponse'
import { oktaAuthConfig } from '../../App'

const getToken = async () => {
  try {
    const accessToken = await oktaAuthConfig.tokenManager.getTokens()
    return accessToken.accessToken?.accessToken || null
  } catch (error) {
    console.error('Error getting access token:', error)
    return null
  }
}
export class ServiceBase {
  public static async get<T>(
    path: string,
    type: ContentType = ContentType.Json
  ): Promise<IObjectResponse<T>> {
    const token = await getToken()
    const init: RequestInit = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      method: 'GET',
    }
    return this.fetchRequest<T>(path, type, init)
  }
  public static async postResponse<T>(
    path: string,
    data: any,
    type: ContentType = ContentType.Json
  ): Promise<IObjectResponse<T>> {
    const token = await getToken()
    const init: RequestInit = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
      method: 'POST',
    }
    return this.fetchRequest<T>(path, type, init)
  }
  public static async delete<T>(
    path: string,
    type: ContentType = ContentType.Json
  ): Promise<IObjectResponse<T>> {
    const token = await getToken()
    const init: RequestInit = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
    }
    return this.fetchRequest<T>(path, type, init)
  }
  public static async putResponse<T>(
    path: string,
    data: any,
    type: ContentType = ContentType.Json
  ): Promise<IObjectResponse<T>> {
    const token = await getToken()
    const init: RequestInit = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
      method: 'PUT',
    }
    return this.fetchRequest<T>(path, type, init)
  }
  private static async fetchRequest<T>(
    path: string,
    type: ContentType,
    init?: RequestInit
  ): Promise<any> {
    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL + '/api' + path,
        init
      )

      if (response.status === 200) {
        switch (type) {
          case ContentType.Text:
            return response.text().then(r => {
              return { success: true, payLoad: r }
            })
          case ContentType.Blob:
            return response.blob().then(r => {
              return { success: true, payLoad: r }
            })
          case ContentType.void:
            return ({} as Promise<T>).then(r => {
              return { success: true, payLoad: r }
            })
          default:
            return response.json().then(r => {
              return { success: true, payLoad: r }
            })
        }
      } else if (response.status === 204) {
        return ({} as Promise<T>).then(r => {
          return { success: true, payLoad: r }
        })
      } else if (response.status === 400 || response.status === 404) {
        return response.text().then(r => {
          console.error(`API error (${response.status})`, r)
          return {
            success: false,
            errorMessage: r,
            errorCode: response.status,
            payLoad: null,
          }
        })
      } else {
        return response.text().then(r => {
          console.error(`API error (${response.status})`, r)
          return {
            success: false,
            errorMessage:
              'Er is iets misgegaan bij de aanroep naar de server. Zie de console (f12) voor meer informatie.',
            errorCode: response.status,
            payLoad: null,
          }
        })
      }
    } catch (e) {
      console.error('error', e)
      return {
        success: false,
        errorMessage:
          'Er is iets misgegaan bij de aanroep naar de server. Zie de console (f12) voor meer informatie.',
        errorCode: 500,
        payLoad: null,
      }
    }
  }
}
